export default "__VITE_ASSET__94900d66__"